import {
  FC,
  useRef,
  useState,
  useEffect,
  MutableRefObject,
  ReactNode,
} from 'react';
import { ProNotification, ProSpin } from '../antd';
import BaseDetailPage, { IBaseProps } from './subpage/baseDetailPage';
import DetailPageContext from './context';
import useDetailPageContext from './hook/useDetailPageContext';
import { getHTMLElement } from '../utils/utils';

export interface DetailCustomAction {
  hide: () => void;
  show: (data?: any) => void;
}
export type DetailCustomActionType = DetailCustomAction | undefined;
export interface DetailPageCustomProps extends IBaseProps {
  /** 加载中 */
  loading?: boolean;
  /** 对象句柄 */
  actionRef?: MutableRefObject<DetailCustomActionType>;
  /** 子节点 */
  children?: ReactNode;
  /** 点击确定时调用接口 */
  fetchApi?: (params?: any) => Promise<any>;
  /** 调用接口之前回调 */
  beforeSubmit?: (values: any) => any;
  /** 接口调用成功 */
  onSuccess?: (res: any) => void;
  /** 接口调用失败 */

  onFail?: (err: any) => void;
  /** 如果传入此方法则提交步骤由外部自行实现 */
  onSubmit?: (values: any) => void;
}
/** 自定义详情页 */
const DetailPageCustom: FC<DetailPageCustomProps> = props => {
  const {
    size,
    confirmLoading,
    actionRef,
    tableId,
    loading,
    children,
    otherHideClassName,
    fetchApi,
    beforeSubmit,
    onSuccess,
    onFail,
    onSubmit,
    ...resProps
  } = props;
  const { visible, pageType, dispatchDetailPage } = useDetailPageContext();
  const [submitLoading, setSubmitLoading] = useState<boolean>(
    confirmLoading || false,
  );
  const tableRef = useRef<HTMLElement>();
  const detailRef = useRef<HTMLDivElement>(null);
  const detailParentRef = useRef<HTMLElement>(); //yb-layout-page-detail
  useEffect(() => {
    if (!tableRef.current) {
      if (tableId) {
        const tableEl = getHTMLElement(tableId);
        if (tableEl) tableRef.current = tableEl;
      } else {
        if (detailRef.current) {
          const parentNode = detailRef.current.parentNode as HTMLElement;
          if (parentNode) {
            if (parentNode.classList.contains('yb-layout-page-detail')) {
              detailParentRef.current = parentNode;
              const el = (parentNode.parentNode as HTMLElement)?.getElementsByClassName?.(
                'yb-layout-page',
              )[0];
              if (el) tableRef.current = el as HTMLElement;
            } else {
              const el = parentNode.getElementsByClassName('yb-table')[0];
              if (el) tableRef.current = el as HTMLElement;
            }
          }
        }
      }
      if (tableRef.current) {
        if (detailParentRef.current) {
          (detailParentRef.current as HTMLDivElement).style.display = visible
            ? 'block'
            : 'none';
        }
        (tableRef.current as HTMLDivElement).style.display = visible
          ? 'none'
          : '';
        handleHidden();
      }
    } else {
      if (detailParentRef.current) {
        (detailParentRef.current as HTMLDivElement).style.display = visible
          ? 'block'
          : 'none';
      } else {
        if (detailRef.current) {
          const parentNode = detailRef.current.parentNode as HTMLElement;
          if (parentNode) {
            if (parentNode.classList.contains('yb-layout-page-detail')) {
              detailParentRef.current = parentNode;
              (detailParentRef.current as HTMLDivElement).style.display = visible
                ? 'block'
                : 'none';
            }
          }
        }
      }
      (tableRef.current as HTMLDivElement).style.display = visible
        ? 'none'
        : '';
      handleHidden();
    }
  }, [visible]);
  const superFormRef = useRef<any>();
  useEffect(() => {
    setSubmitLoading(confirmLoading || false);
  }, [confirmLoading]);
  const handleHidden = () => {
    if (otherHideClassName) {
      const classEle = document.getElementsByClassName(otherHideClassName);
      for (let val of Object.values(classEle)) {
        (val as HTMLElement).style.display = visible ? 'none' : '';
      }
    }
  };
  const handleOk = () => {
    superFormRef.current
      ?.validateFields()
      .then((values: any) => {
        superFormRef.current.submit();
      })
      .catch((errorInfo: any) => {
        if (Array.isArray(errorInfo.errorFields)) {
          const messageNode = (
            <>
              {errorInfo.errorFields.map((v: any) => (
                <div key={v.name[0]}>{v.errors[0]}</div>
              ))}
            </>
          );
          ProNotification.warning({
            message: messageNode,
          });
        }
      });
  };

  if (actionRef && typeof actionRef !== 'function') {
    actionRef.current = {
      hide: () => {
        dispatchDetailPage('change', { visible: false });
      },
      show: () => {
        dispatchDetailPage('change', { visible: true });
      },
    };
  }
  return (
    <>
      {visible ? (
        <div ref={detailRef} className="tl-detail-wrappper">
          <DetailPageContext.Provider
            value={{ visible, pageType, dispatchDetailPage }}
          >
            <ProSpin spinning={loading}>
              <BaseDetailPage
                {...resProps}
                size={size}
                onOk={handleOk}
                confirmLoading={submitLoading}
              >
                {children}
              </BaseDetailPage>
            </ProSpin>
          </DetailPageContext.Provider>
        </div>
      ) : null}
    </>
  );
};

DetailPageCustom.defaultProps = {
  loading: false,
  size: 'full',
  hideOkButton: true,
};

export default DetailPageCustom;
